module.exports = __webpack_public_path__ + "img/Getier.34e36d73.svg";